import React, { useState } from "react";
import Refuse from "./refuse";
import Approve from "./approve";

function ReportDetailsModal({ selectedReport, adminName }) {
  const [zoomedImage, setZoomedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [targetCars, setTargetCars] = useState("");

  const date = new Date(selectedReport?.date);
  const formattedDate = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  const combinedMedia = [
    ...(selectedReport?.photos || []),
    ...(selectedReport?.videos || []),
  ];
  //console.log("selectedReport ID in modal:", selectedReport?.id);

  // const isVideo = (media) =>
  //   media.endsWith(".mp4") || media.endsWith(".avi") || media.endsWith(".mov");

  const isVideo = (media) => {
  if (!media || typeof media !== "string") return false; // ✅ guard
  const lower = media.split("?")[0].toLowerCase();      // remove query params
  return lower.endsWith(".mp4") || lower.endsWith(".avi") || lower.endsWith(".mov");
};

  // 🔹 Normal carousel navigation (no auto-zoom)
  const prevSlide = () => {
    const newIndex =
      (currentIndex - 1 + combinedMedia.length) % combinedMedia.length;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const newIndex = (currentIndex + 1) % combinedMedia.length;
    setCurrentIndex(newIndex);
  };

  // 🔹 Fullscreen navigation (updates zoomed image)
  const prevZoomed = () => {
    const newIndex =
      (currentIndex - 1 + combinedMedia.length) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  const nextZoomed = () => {
    const newIndex = (currentIndex + 1) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  return (
    <>
      <input type="checkbox" id="my-modal-5" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl rounded-2xl bg-white p-6 shadow-xl">
          {/* Header */}
          <div className="mb-4 flex items-center justify-between">
            <h3 className="w-full text-center text-lg font-bold text-brand-500">
              Detajet e raportit #{selectedReport?.reportName}
            </h3>
            <label
              htmlFor="my-modal-5"
              className="btn btn-circle btn-sm bg-white text-brand-700 hover:text-white"
              onClick={() => setZoomedImage(null)}
            >
              ✕
            </label>
          </div>
          <hr />

          {/* Report Info */}
          <div className="mt-4 space-y-3">
            <p>
              <span className="font-bold">Qyteti:</span>{" "}
              {selectedReport?.address
                ? (() => {
                    const gpsMatch =
                      selectedReport.address.match(/\(([^)]+)\)/);
                    const cityName = selectedReport.address
                      .split("(")[0]
                      .trim();

                    if (gpsMatch && gpsMatch[1]) {
                      const [lat, lng] = gpsMatch[1]
                        .split(",")
                        .map((x) => x.trim());
                      const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

                      return (
                        <>
                          <span>{cityName} </span>
                          <span>(</span>
                          <a
                            href={googleMapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer font-semibold text-blue-600 underline"
                            title="Shiko lokacionin në Google Maps"
                          >
                            {lat}, {lng}
                          </a>
                          <span>)</span>
                        </>
                      );
                    }
                    return <span>{selectedReport.address}</span>;
                  })()
                : "Unknown"}
            </p>
            <p>
              <span className="font-bold">Kategoria:</span>{" "}
              {selectedReport?.category}
            </p>
            <p>
              <span className="font-bold">Data:</span> {formattedDate}
            </p>
            <p className="break-words">
              <span className="font-bold">Përshkrimi:</span>{" "}
              {selectedReport?.textContent || "N/A"}
            </p>
          </div>

          {/* Media Carousel */}
          {combinedMedia.length > 0 && (
            <div className="relative mx-auto mt-6 flex max-w-2xl items-center justify-center">
              <div className="relative">
                {isVideo(combinedMedia[currentIndex]) ? (
                  <video
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full rounded-lg object-contain shadow"
                    controls
                  />
                ) : (
                  <img
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full cursor-pointer rounded-lg object-contain shadow transition hover:scale-105"
                    alt={`media-${currentIndex + 1}`}
                    onClick={() => setZoomedImage(combinedMedia[currentIndex])}
                  />
                )}

              <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
                <span
                  className="font-bold text-white/30 break-words"
                  style={{
                    transform: "rotate(-45deg)",
                    userSelect: "none",
                    width: "90%",             // makes text respect image width
                    textAlign: "center",
                    fontSize: "clamp(14px, 4vw, 50px)",  // auto-resize
                    lineHeight: "1.1",
                    wordBreak: "break-word",
                  }}
                >
                  {adminName}
                </span>
              </div>
              </div>
              {combinedMedia.length > 1 && (
                <>
                  <button
                    onClick={prevSlide}
                    className="btn btn-circle absolute left-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❮
                  </button>
                  <button
                    onClick={nextSlide}
                    className="btn btn-circle absolute right-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❯
                  </button>
                </>
              )}
            </div>
          )}

          {/* Target Cars */}
          {/* <div className="mt-6">
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Targat e makies
            </label>
            <input
              type="text"
              value={targetCars}
              onChange={(e) => setTargetCars(e.target.value)}
              placeholder="Shënoni makinat target (p.sh., ABC-123, XYZ-789)"
              className="w-full rounded-lg border border-gray-300 p-2 focus:border-brand-500 focus:ring focus:ring-brand-200"
            />
          </div> */}

          {/* Footer */}
          <footer className="modal-action mt-6 flex justify-end gap-2">
            <label
              htmlFor="my-modal-5"
              className="btn border-0 bg-white text-brand-700 hover:text-white"
            >
              Kthehu
            </label>

            {/* Refuse logic */}
            <label
              htmlFor="my-modal-6"
              className="btn border-0 bg-red-500 text-white hover:bg-red-600"
            >
              Refuzo
            </label>
            <Refuse id={selectedReport?.id} />

            {/* Approve logic */}
            <Approve id={selectedReport?.id} targetCars={targetCars}>
              {(sendApproval) => (
                <button
                  onClick={sendApproval}
                  className="btn border-0 bg-brand-500 text-white hover:bg-brand-700"
                >
                  Aprovo
                </button>
              )}
            </Approve>
          </footer>
        </div>
      </div>

      {/* Fullscreen Image Viewer */}
      {zoomedImage && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90">
          <button
            className="absolute right-4 top-4 text-3xl text-white"
            onClick={() => setZoomedImage(null)}
          >
            ✕
          </button>
          {combinedMedia.length > 1 && (
            <>
              <button
                onClick={prevZoomed}
                className="absolute left-5 text-4xl text-white"
              >
                ❮
              </button>
              <button
                onClick={nextZoomed}
                className="absolute right-5 text-4xl text-white"
              >
                ❯
              </button>
            </>
          )}
        <div className="relative">
  {isVideo(zoomedImage) ? (
    <video
      src={zoomedImage}
      className="max-h-full max-w-full rounded-lg object-contain shadow-lg"
      controls
    />
  ) : (
    <img
      src={zoomedImage}
      className="max-h-full max-w-full rounded-lg object-contain shadow-lg"
      alt="Zoomed Media"
    />
  )}

  {/* Watermark on fullscreen media */}
  <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
    <span
      className="font-bold text-white/30 break-words"
      style={{
        transform: "rotate(-45deg)",
        userSelect: "none",
        width: "90%",                // fit inside media
        textAlign: "center",
        fontSize: "clamp(14px, 4vw, 50px)",
        lineHeight: "1.1",
        wordBreak: "break-word",
      }}
    >
      {adminName}
    </span>
  </div>
</div>
        </div>
      )}
    </>
  );
}

export default ReportDetailsModal;
